import { render, staticRenderFns } from "./addFree.vue?vue&type=template&id=4ccfaf2c&"
import script from "./addFree.vue?vue&type=script&lang=js&"
export * from "./addFree.vue?vue&type=script&lang=js&"
import style0 from "./addFree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports